import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarning,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import '../../../scss/Components/_modal.scss';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import { getToast } from '../../../utils/toastConfig';

function ModalCActivate(props) {
  const navigate = useNavigate();
  const {
    clientModalDeleteString,
    clientMDClientString,
    clientMDEDateString,
    modalYesString,
    modalNoString,
  } = useTranslationHook();

  var activateClientBusiness = localStorage.getItem('clientBusinessToActivate');
  var activateClientCreatedDate = localStorage.getItem(
    'clientCreatedDateToActivate'
  );

  var activateClientId = localStorage.getItem('clientIdToActivate');

  function activateClient() {
    customAxios
      .request({
        url: `${GlobalVariables.getURL()}activateClient/${activateClientId}`,
        method: 'patch',
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        console.log(response.data);
        hideS();
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Verifica si el error es 401 Unauthorized
          navigate('/nonauth'); // Redirige a la ruta de no autenticación

          localStorage.removeItem('token');
          localStorage.setItem('isAuthenticated', 'false');
        } else {
          getToast({
            status: 'error',
            title: 'Error al activar Plaza. Vuelve a intentarlo.',
          });
        }
      });
  }

  function hideS() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Plaza activada exitosamente en la base de datos.',
    });
    props.getClients();
  }

  function hideN() {
    props.onHide();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
          ¿Quieres activar esta plaza?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="delete-info">
          <strong>{clientMDClientString}:</strong> {activateClientBusiness}
        </span>
        <br />
        <span className="delete-info">
          <strong>{clientMDEDateString}:</strong> {activateClientCreatedDate}
        </span>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="modal-button"
          onClick={() => {
            activateClient();
          }}
        >
          <FontAwesomeIcon icon={faWarning} /> Si, quiero activar esta plaza
        </button>
        <button
          className="modal-button no"
          onClick={() => {
            hideN();
          }}
        >
          <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCActivate;
